import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { SiIeee, SiResearchgate } from "react-icons/si";

const ResumeCard = ({ duration, title, link, ieeeUrl, researchGateUrl, subTitle, des }) => {
  return (
    <div className="w-full py-6 flex flex-col gap-2.5 border-b-[1px] border-b-zinc-800">
      {duration.includes('Present') ? (
        <h6 className="w-40 text-center text-sm py-[1px] text-designColor border-[1px] border-designColor rounded-sm">
          {duration}
        </h6>
      ) : (
        <h6 className="w-40 text-center text-sm py-[1px] text-[#999] border-[1px] border-zinc-600 rounded-sm">
          {duration}
        </h6>
      )}
      <div className="flex justify-between">
        <h2 className="text-lg font-titleFont text-gray-200 font-medium">
          {title}
        </h2>
        {link && (
          <a href={link} target="_blank" rel="noreferrer">
            <FaExternalLinkAlt className="text-lg hover:text-designColor cursor-pointer" />
          </a>
        )}

      </div>
      <p className="text-sm text-[#999] -mt-2">{subTitle}</p>
      <p className="text-base text-[#999] font-medium pr-10 hidden lgl:block">{des}</p>
      {
        ieeeUrl && researchGateUrl && (
          <div className="mt-2 flex items-center gap-2">
            <a href={researchGateUrl} target="_blank" rel="noreferrer" className="text-textColor underline  border-[1px] border-zinc-700 px-2 py-3 rounded-md hover:bg-designColor hover:border-designColor w-fit">
              <SiResearchgate size="1.2em" />
            </a>
            <a href={ieeeUrl} target="_blank" rel="noreferrer" className="text-textColor underline border-[1px] border-zinc-700 px-2 py-0 rounded-md hover:bg-designColor hover:border-designColor w-fit">
              <SiIeee size="2.6em" />
            </a>
          </div>
        )
      }
    </div>
  );
};

export default ResumeCard;
